export default __webpack_public_path__ + "static/media/img-seg-run.3351a536.jpg";